// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__11rEy","footer":"ChangeClinic_footer__1raXy"};